import CloseIcon from "@components/icons/CloseIcon";
import {
  AlertDialogContext,
  AlertDialogType,
} from "@contexts/AlertDialogContext";
import React, { useContext } from "react";
import { Modal } from "react-bootstrap";

export function AlertDialog() {
  const { hidden, hide, type, message } = useContext(AlertDialogContext);

  return (
    <>
      <Modal
        show={!hidden}
        backdrop={type === AlertDialogType.Loading ? "static" : true}
        onHide={() => {
          hide();
        }}
        dialogClassName="max-w-lg"
      >
        <Modal.Header>
          <Modal.Title>
            {type == AlertDialogType.Success && (
              <p className="text-green">Success</p>
            )}
            {type == AlertDialogType.Error && (
              <p className="text-red">Failed</p>
            )}
            {type == AlertDialogType.Loading && (
              <p className="text-white">Please Wait</p>
            )}
          </Modal.Title>

          {/* {
                    type != AlertDialogType.Loading &&
                    <button onClick={() => hide()} type="button" className="btn-close" aria-label="Close">
                        <CloseIcon />
                    </button>
                } */}
        </Modal.Header>
        <Modal.Body className="p-6 text-center">
          {type == AlertDialogType.Loading && (
            <div className="mb-4 text-center">
              <div className="loader m-auto"></div>
            </div>
          )}
          {message && <p className="text-center dark:text-white">{message}</p>}

          {(message ?? "")
            .toString()
            .includes(
              "signature verification failed; please verify account number"
            ) && <p className="mt-2 text-start text-green">Please use Station Mobile,Keplr extension, Luncdash or Cosmostation wallet for this Transaction. <strong>Bug fixes in progress</strong></p>}
        </Modal.Body>
      </Modal>
    </>
  );
}
